import './css/Home.css'

const Home = () => {
    return <div className='home-page'></div>
}

export default Home;